import * as staticDataActions from "../../../actions/temp/staticData/staticDataActions";

export const INITIAL_STATE = {
  // Sourced from: https://www.iso.org/iso-4217-currency-codes.html (via https://www.six-group.com/dam/download/financial-information/data-center/iso-currrency/lists/list_one.xls)
  currencyCodesList: [
    "AED",
    "AFN",
    "ALL",
    "AMD",
    "ANG",
    "AOA",
    "ARS",
    "AUD",
    "AWG",
    "AZN",
    "BAM",
    "BBD",
    "BDT",
    "BGN",
    "BHD",
    "BIF",
    "BMD",
    "BND",
    "BOB",
    "BOV",
    "BRL",
    "BSD",
    "BTN",
    "BWP",
    "BYN",
    "BZD",
    "CAD",
    "CDF",
    "CHE",
    "CHF",
    "CHW",
    "CLF",
    "CLP",
    "CNY",
    "COP",
    "COU",
    "CRC",
    "CUC",
    "CUP",
    "CVE",
    "CZK",
    "DJF",
    "DKK",
    "DOP",
    "DZD",
    "EGP",
    "ERN",
    "ETB",
    "EUR",
    "FJD",
    "FKP",
    "GBP",
    "GEL",
    "GHS",
    "GIP",
    "GMD",
    "GNF",
    "GTQ",
    "GYD",
    "HKD",
    "HNL",
    "HRK",
    "HTG",
    "HUF",
    "IDR",
    "ILS",
    "INR",
    "IQD",
    "IRR",
    "ISK",
    "JMD",
    "JOD",
    "JPY",
    "KES",
    "KGS",
    "KHR",
    "KMF",
    "KPW",
    "KRW",
    "KWD",
    "KYD",
    "KZT",
    "LAK",
    "LBP",
    "LKR",
    "LRD",
    "LSL",
    "LYD",
    "MAD",
    "MDL",
    "MGA",
    "MKD",
    "MMK",
    "MNT",
    "MOP",
    "MRU",
    "MUR",
    "MVR",
    "MWK",
    "MXN",
    "MXV",
    "MYR",
    "MZN",
    "NAD",
    "NGN",
    "NIO",
    "NOK",
    "NPR",
    "NZD",
    "OMR",
    "PAB",
    "PEN",
    "PGK",
    "PHP",
    "PKR",
    "PLN",
    "PYG",
    "QAR",
    "RON",
    "RSD",
    "RUB",
    "RWF",
    "SAR",
    "SBD",
    "SCR",
    "SDG",
    "SEK",
    "SGD",
    "SHP",
    "SLE",
    "SLL",
    "SOS",
    "SRD",
    "SSP",
    "STN",
    "SVC",
    "SYP",
    "SZL",
    "THB",
    "TJS",
    "TMT",
    "TND",
    "TOP",
    "TRY",
    "TTD",
    "TWD",
    "TZS",
    "UAH",
    "UGX",
    "USD",
    "USN",
    "UYI",
    "UYU",
    "UYW",
    "UZS",
    "VED",
    "VES",
    "VND",
    "VUV",
    "WST",
    "XAF",
    "XAG",
    "XAU",
    "XBA",
    "XBB",
    "XBC",
    "XBD",
    "XCD",
    "XDR",
    "XOF",
    "XPD",
    "XPF",
    "XPT",
    "XSU",
    "XTS",
    "XUA",
    "XXX",
    "YER",
    "ZAR",
    "ZMW",
    "ZWL",
    // Some crypto
    "BTC",
    "ETH",
  ],
  validClaimsFileFormats: [],
  inflationModelConfig: {},
  analyticsConfig: null,
  sovTortCaps: null,
  config: {},
};

const staticDataReducer = (state = INITIAL_STATE, action) => {
  if (state === undefined) {
    state = INITIAL_STATE;
  }
  switch (action.type) {
    case staticDataActions.retrieveValidClaimsFileFormats.succeeded.toString():
      return {
        ...state,
        validClaimsFileFormats: action.payload,
      };
    case staticDataActions.retrieveInflationModelConfig.succeeded.toString():
      return {
        ...state,
        inflationModelConfig: action.payload,
      };
    case staticDataActions.retrieveAnalyticsConfig.succeeded.toString():
      return {
        ...state,
        analyticsConfig: action.payload,
      };
    case staticDataActions.retrieveSovTortCaps.succeeded.toString():
      return {
        ...state,
        sovTortCaps: action.payload,
      };
    case staticDataActions.retrieveConfig.succeeded.toString():
      return {
        ...state,
        config: {
          ...state.config,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};

export default staticDataReducer;
